module.exports = __webpack_public_path__ + "static/watermark_footer_homes_mobile-d41e194aa017b857bf904d57d9fcfd9a.png";